import { useSelector } from 'react-redux';
import { useGetPermissionsQuery, useGetRolesQuery } from '@/features/auth/auth.api.ts';
import { RootState } from '@/redux/store.ts';

export const useAuthBootstrap = () => {
  const token = useSelector((state: RootState) => state.auth.user?.token ?? '');
  const skip = !token;
  useGetPermissionsQuery(undefined, { skip, pollingInterval: 300000 });
  useGetRolesQuery(undefined, { skip, pollingInterval: 300000 });
};
